import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators, AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { CommonService } from 'app/_services/common.service'
import * as jspdf from 'jspdf';

import html2canvas from 'html2canvas';
import { toBase64String } from '@angular/compiler/src/output/source_map';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css']
})
export class PrintComponent implements OnInit {

  emailForm = this
    .formBuilder
    .group({
      email: [
        '', Validators.required
      ],
      optInfo: [
        ''
      ]
    });

    public moduleData;
    public isprint = false;
    public printObj;
    public foodServiceResp;
    title = 'html-to-pdf-angular-application';

  constructor(
    public dialogRef: MatDialogRef<PrintComponent>,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService : CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.moduleData = data;
    this.foodServiceResp = data.id;
    console.log("email", this.foodServiceResp);
   }

  ngOnInit(): void {
    this.printObj = this.moduleData.id;
  }

  navigateFromLogin(){
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if(isLoggedIn === "true"){
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login")
    }
  }

  navigateMenu(){
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }

  onPrint(){
    this.isprint = true;
    console.log(this.moduleData.htmlData);
   
   
  }

  exportAsPDF(dataFlag: any) {
    let service = localStorage.getItem('Eservice');
    let doc = new jspdf.jsPDF();
    var width = doc.internal.pageSize.getWidth();
    var height = doc.internal.pageSize.getHeight();
    // Empty square
    doc.rect(10, 10, width - 20, height - 20);
    let currentLine = 20;
    if (this.foodServiceResp.name !== undefined) {
      currentLine = this.addHeaderData(
        doc,
        this.foodServiceResp.name,
        currentLine
      );
    }
    if (this.foodServiceResp.description !== undefined) {
      currentLine = this.addMultipleRow(
        doc,
        this.foodServiceResp.description,
        currentLine,
        true
      );
    }
    if (this.foodServiceResp.sub_description !== undefined) {
      currentLine = this.addMultipleRow(
        doc,
        this.foodServiceResp.sub_description,
        currentLine,
        true
      );
    }
    if (
      this.foodServiceResp.address1 !== undefined &&
      this.foodServiceResp.address2 !== undefined
    ) {
      currentLine = this.addHeaderData(doc, "Location :", currentLine);

      currentLine = this.addMultipleRow(
        doc,
        this.foodServiceResp.address1,
        currentLine,
        true
      );
      currentLine = this.addMultipleRow(
        doc,
        this.foodServiceResp.address2,
        currentLine,
        false
      );
    }
    currentLine = this.addHeaderData(doc, "Hours :", currentLine);
    currentLine = this.addMultipleRow(
      doc,
      this.foodServiceResp.hours_of_operation,
      currentLine,
      true
    );
    // Phone/Fax Numbers
    currentLine = this.addHeaderData(doc, "Phone/Fax Numbers :", currentLine);
    currentLine = this.addMultipleRow(
      doc,
      this.foodServiceResp.main_number,
      currentLine,
      true
    );
    currentLine = this.addMultipleRow(
      doc,
      this.foodServiceResp.fax_number,
      currentLine,
      false
    );
    //Email Address:
    currentLine = this.addHeaderData(doc, "Email Address :", currentLine);
    currentLine = this.addMultipleRow(
      doc,
      this.foodServiceResp.email,
      currentLine,
      true
    );
    // Intake Procedure:
    currentLine = this.addHeaderData(doc, "Intake Procedure :", currentLine);
    currentLine = this.addMultipleRow(
      doc,
      this.foodServiceResp.intake_procedure,
      currentLine,
      true
    );
    currentLine = this.addHeaderData(doc, "Services :", currentLine);
    currentLine = this.addMultipleRow(
      doc,
      service,
      currentLine,
      true
    );
    var term_data =
      "* The community resource directory information is up to date to the best of our knowledge. However, you should always call the provider to confirm this information and make an appointment. Be sure to confirm payment information with the provider, if payment is required. Pennsylvania 211 does not rate, recommend or endorse any agency. We simply provide information as a public service.";
    currentLine = currentLine + 30;
    doc.rect(15, currentLine, width - 30, 40);
    currentLine = this.addMultipleRow(doc, term_data, currentLine, true, 165);
    //For saving pdf
    if (dataFlag == 'pdf') {
      doc.save("211_food_agency.pdf");
      this.dialogRef.close({
        event: 'pdf',
        isUpdated: true
      })
    }
    // if (dataFlag == 'print') {
    //   doc.autoPrint();
    //   window.open(doc.output("bloburl").toString(), "_blank");

    // }
    // if (dataFlag == "pdf") {
    //   doc.save("test.pdf");
    // }
    else if (dataFlag == "print") {
      doc.autoPrint();
      window.open(doc.output("bloburl").toString(), "_blank");
      
      
    }else if(dataFlag=="email"){
      let base64Data=doc.output('datauristring');
      let emailValue= this.emailForm.value;
      if(emailValue.email != '' && emailValue.email != null && emailValue.email != undefined){
        console.log("Eamil=",emailValue.email);
        console.log("Base64Data=",base64Data);
        let splitBase64Data= base64Data.split(',');
        this.emailData(emailValue,splitBase64Data[1]);
      }
      else{
        alert("Please fill in the Email")
      }
     

    }
  }

  emailData(emailValue,base64Data){
   console.log(emailValue,'inside email data');
   if(emailValue.optInfo == undefined || emailValue.optInfo == null){
    emailValue.optInfo = " ";
   }
    this.commonService.emailData(emailValue.email,emailValue.optInfo,base64Data).subscribe(res=>{
      console.log(res,'email data res');
      alert("Document has been sent to" + " "  +`${emailValue.email}`);
      this.dialogRef.close({
        event: 'email',
        isUpdated: true
      })
    })
   
   
  }


  addHeaderData(doc: jspdf.jsPDF, data: any, currentLine: any) {
    currentLine = currentLine + 7;
    doc.setFont("helvetica", "bold");
    doc.text(data, 20, currentLine);
    return currentLine;
  }
  addMultipleRow(
    doc: jspdf.jsPDF,
    data: any,
    currentLine: any,
    addAnotherSpace: boolean,
    countOfCharacter: number = 180
  ) {
    doc.setFont("times", "normal");
    doc.setFontSize(12);
    var splitString = doc.splitTextToSize(data, countOfCharacter);
    if (addAnotherSpace) {
      currentLine = currentLine + 7;
    }
    var y = currentLine;
    for (var i = 0; i < splitString.length; i++) {
      if (y > 280) {
        y = 10;
        doc.addPage();
      }
      doc.text(splitString[i], 20, y, {
        align: "left",
      });
      y = y + 7;
    }
    currentLine = y;
    return currentLine;
  }
  
  
}
